import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { authenticatedRoute } from './_authenticated';

// Code splitting: Lazy load GalleryPage to reduce initial bundle size
const GalleryPage = lazy(() => import('@/pages/GalleryPage'));

export const galleryRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/gallery',
  component: GalleryPage,
});

// Backward compatibility
export const Route = galleryRoute;
